module.exports = __webpack_public_path__ + "static/media/14.99f33b11.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/lhand/14.png
// module id = 754
// module chunks = 0